import { useState } from "react";
import { faqs } from "@/mocks/guaContent";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="relative bg-background-50 py-16 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-semibold text-primary-600 tracking-wide">FAQ · 常见问题</p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900">
            关于订阅，你想知道的都在这里
          </h2>
        </div>

        <div className="mt-10 flex flex-col divide-y divide-background-200 border border-background-200 rounded-lg overflow-hidden bg-background-100/60">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-4 text-left"
                >
                  <span className="font-heading text-base font-bold text-foreground-900 leading-snug">
                    {f.q}
                  </span>
                  <span
                    className={
                      "shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition " +
                      (isOpen ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-700")
                    }
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                <div
                  className={
                    "grid transition-all duration-300 ease-in-out " +
                    (isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0")
                  }
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-7 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}